import Commons from '../../../../Services/Common/Common';

export const M_TBM_CUSTOM_01_Schema = {
  mapper: {
    /** TBM 참석 취소 SP_TBM_MEMBER_D2 */
    delete1: {
      UserId: (_, context) => context.userInfo?.userid,
      TbmCd: (row) => Commons.EncryptAES(row.tbmCd ?? ''),
    },
  },
};
